module.exports = __webpack_public_path__ + "static/media/bookmark2.775d019b.png";